/* eslint-disable no-unused-vars */
import barOptions from '../chartjs/barOptions';
import doughnutOptions from '../chartjs/doughnutOptions';
import initChart from '../chartjs/initChart';
import observeElements from '../util/observeElements';

// import {Chart} from 'chart.js';

(function ($, wpApiSettings) {
  const load = (id, callback) => {
    let ajaxUrl = wpApiSettings.root + 'stats/get?id=' + id;

    $.ajax({
      url: ajaxUrl,
      method: 'GET',
      beforeSend: function (xhr) {
        xhr.setRequestHeader('X-WP-Nonce', wpApiSettings.nonce);
      },
    }).done(function (response) {
      if ('function'=== typeof callback) {
        callback(response);
      }
    }).always(function () {

    });
  };

  /**
   * initializeBlock
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    15/4/19
   * @since   1.0.0
   *
   * @param  $block object The block jQuery element.
   * @param  attributes object The block attributes (only available when editing).
   * @return  void
   */
  const initializeBlock = function ($block) {
    const canvasId = $block.attr('id') + '-canvas';
    const ctx = document.getElementById(canvasId).getContext('2d');
    const uid = $block.data('uid');
    let type = '';
    let title = '';
    let showTitle = true;
    let centerText = '';
    let usePercent = false;
    let chartData = {
      labels: [],
      datasets: [],
    };
    let options = {};

    load(uid, (response) => {
      type = response.type;
      showTitle = Boolean(response.show_title);
      title = showTitle ? response.title:'';
      usePercent = Boolean(response.percent);
      centerText = response.centered_text;

      chartData.labels = response.labels;
      chartData.datasets = response.datasets;

      /**
       * Find the highest value we have in our datasets
       */
      const maxRow = chartData.datasets.map(function (row) {
        return Math.max.apply(Math, row.data);
      });
      const suggestedMax = Math.max.apply(null, maxRow) * 1.1;

      options = barOptions({
        title: title,
        suggestedMax: usePercent ? null : suggestedMax,
        usePercent: usePercent,
      });

      let useGradient = false;

      if ('bar'===type) {
        chartData.datasets = chartData.datasets.map((dataset) => {
          dataset.barPercentage = 1;

          return dataset;
        });
      }

      if ('line'===type) {
        useGradient = true;
        chartData.datasets = chartData.datasets.map((dataset) => {
          dataset.borderColor = dataset.backgroundColor;

          return dataset;
        });
      }

      if ('doughnut'===type) {
        options = doughnutOptions({
          title: title,
          centerText: centerText,
        });
      }

      /**
       * Crate a gradient from background-color
       * @type {boolean}
       */
      if (useGradient) {
        const canvasHeight = ctx.canvas.height ? ctx.canvas.height:275;
        chartData.datasets = chartData.datasets.map((dataset) => {
          let obj = Object.assign({}, dataset);
          let gradient = ctx.createLinearGradient(0, 0, 0, canvasHeight);
          gradient.addColorStop(0, dataset.backgroundColor);
          gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
          obj.fill = 'start';
          obj.backgroundColor = gradient;
          return obj;
        });
      }

      observeElements('#' + canvasId, function () {
        initChart(ctx, {
          type: type,
          chartData: chartData,
          options: options,
        });
      });
    });
  };


  // Initialize each block on page load (front end).
  $(document).ready(function () {
    $('.block-stats').each(function () {
      initializeBlock($(this));
    });
  });

  // Initialize dynamic block preview (editor).
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=block-stats', initializeBlock);
  }

// eslint-disable-next-line no-undef
})(jQuery, wpApiSettings);
